// extracted by mini-css-extract-plugin
module.exports = {"input":"Input_input__3bchA","hideNumberArrows":"Input_hideNumberArrows__1HZdM","select":"Input_select__2x7iW"};